import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </C>
  );
};

const LINE = { hidden: { y: "110%" }, show: { y: "0%" } };

export const MaskLine = ({ children, delay = 0, className = "", inView = false }) => {
  const trigger = inView ? { whileInView: "show", viewport: { once: true, amount: 0 } } : { animate: "show" };
  return (
    <motion.span className="block overflow-hidden pb-[0.12em] -mb-[0.12em]" initial="hidden" {...trigger}>
      <motion.span className={`block ${className}`} variants={LINE} transition={{ duration: 1.1, delay, ease: EASE }}>
        {children}
      </motion.span>
    </motion.span>
  );
};

export const SectionHeading = ({ eyebrow, title, script, align = "left", testid }) => (
  <div className={`relative ${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`} data-testid={testid}>
    <Reveal>
      <p className="eyebrow mb-4">{eyebrow}</p>
    </Reveal>
    <h2 className="text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-ink">
      <MaskLine inView>{title}</MaskLine>
      {script && (
        <MaskLine inView delay={0.12} className="font-script text-gold text-[0.9em] tracking-normal">
          {script}
        </MaskLine>
      )}
    </h2>
  </div>
);
